import Image from 'next/image';
import { Newspaper } from 'lucide-react';

interface NewsVisualProps {
  image?: string;
  alt: string;
  sizes?: string;
  priority?: boolean;
  loading?: 'eager' | 'lazy';
  imageClassName?: string;
}

export default function NewsVisual({
  image,
  alt,
  sizes,
  priority,
  loading,
  imageClassName = 'object-cover',
}: Readonly<NewsVisualProps>) {
  if (image) {
    return (
      <picture>
        <source media="(max-width: 640px)" srcSet={image.replace(/\.webp$/, '.mobile.webp')} />
        <Image
          src={image}
          alt={alt}
          fill
          sizes={sizes}
          priority={priority}
          loading={loading}
          className={imageClassName}
        />
      </picture>
    );
  }

  return (
    <div
      role="img"
      aria-label={alt}
      className="bg-navy-dark absolute inset-0 flex items-center justify-center overflow-hidden text-white"
    >
      <div className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-red-600/30 blur-2xl" />
      <div className="absolute -bottom-12 -left-10 h-36 w-36 rounded-full bg-blue-500/20 blur-2xl" />
      <div className="relative flex flex-col items-center gap-3 px-5 text-center">
        <Newspaper className="text-red" size={32} />
        <span className="text-xs font-black tracking-[0.2em] uppercase">Dynamic Club</span>
      </div>
    </div>
  );
}
